<script setup lang="ts">

import { faCopy } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { BtnIcon } from '@shared/ui/buttons'

import { useDisciplinePaymentLinkField } from '../model/discipline-payment-link-field.hook'

defineOptions({
  name: 'DisciplinePaymentLinkField',
})

const props = withDefaults(defineProps<{
  label: string
  link: string
  colored?: boolean
}>(), {
  colored: false,
})

const {
  refIsSupported,
  refIsCopied,
  copyLink,
} = useDisciplinePaymentLinkField({
  link: computed(() => props.link),
})
</script>

<template>
  <div class="discipline-payment-link-field">
    <AppText
      name="body2"
      color="slate-900"
    >
      {{ label }}
    </AppText>
    <div class="discipline-payment-link-field__row">
      <div class="discipline-payment-link-field__box">
        <span
          :class="['discipline-payment-link-field__value', { empty: !link, colored }]"
        >
          {{ link || label }}
        </span>
      </div>
      <BtnIcon
        v-if="refIsSupported"
        :class="refIsCopied ? 'copied' : 'not-copied'"
        :icon="faCopy"
        tooltip-text="Link copied"
        :disabled="!link"
        @click="copyLink"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplinePaymentLinkField.scss" />
